import { getSafe } from 'src/app/shared/util/get-safe';
import { AccessControlEntry } from '../auth/access-control-entry';
import { Directive, Input, ViewContainerRef, OnInit, ElementRef, TemplateRef, EmbeddedViewRef } from '@angular/core';
import { UserService } from 'src/app/users/shared/user.service';

@Directive({
  selector: '[wlAccessControl]',
  standalone: false
})
export class AccessControlDirective implements OnInit {
  public accessControl: AccessControlEntry;
  public inactive = false;
  public securityLoaded = false;
  private _thenTemplateRef: TemplateRef<any> | null = null;
  private _elseTemplateRef: TemplateRef<any> | null = null;
  private _thenViewRef: EmbeddedViewRef<any> | null = null;
  private _elseViewRef: EmbeddedViewRef<any> | null = null;

  @Input() set wlAccessControl(accessControlEntry: any) {
    this.accessControl = this.ensureValidAccessControlEntry(accessControlEntry);
    this._userService.getCurrentUserSecurityElementAccessLevel(this.accessControl.SecurityElement).then(userAccessLevel => {
      this.securityLoaded = true;
      this.inactive = userAccessLevel < this.accessControl.MinimumAccessLevel;
      this.updateView();
    });
  }
  @Input() set wlAccessControlElse(templateRef: TemplateRef<any> | null) {
    this.assertTemplate('ngIfElse', templateRef);
    this._elseTemplateRef = templateRef;
    this._elseViewRef = null; // clear previous view if any.
    if (this.securityLoaded) {
      this.updateView();
    }
  }

  constructor(
    private _userService: UserService,
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    templateRef: TemplateRef<any>
  ) {
    this._thenTemplateRef = templateRef;
  }

  ngOnInit() {}

  updateView() {
    if (!this.inactive) {
      if (!this._thenViewRef) {
        this._viewContainer.clear();
        this._elseViewRef = null;
        if (this._thenTemplateRef) {
          this._thenViewRef = this._viewContainer.createEmbeddedView(this._thenTemplateRef);
        }
      }
    } else {
      if (!this._elseViewRef) {
        this._viewContainer.clear();
        this._thenViewRef = null;
        if (this._elseTemplateRef) {
          this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef);
        }
      }
    }
  }

  assertTemplate(property: string, templateRef: TemplateRef<any> | null): void {
    const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
    if (!isTemplateRefOrNull) {
      throw new Error(`${property} must be a TemplateRef, but received '${templateRef}'.`);
    }
  }

  private ensureValidAccessControlEntry(accessControlEntry: any) {
    if (typeof accessControlEntry === 'string') {
      return {
        SecurityElement: accessControlEntry,
        MinimumAccessLevel: 1, // read-only
      } as AccessControlEntry;
    } else {
      if (!getSafe(() => accessControlEntry.SecurityElement) || isNaN(getSafe(() => accessControlEntry.MinimumAccessLevel))) {
        throw new Error(`Invalid object for AccessControl: ${JSON.stringify(accessControlEntry)}`);
      }
    }
    return accessControlEntry as AccessControlEntry;
  }
}
